var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-h-screen bg-gray-50 font-sans",attrs:{"id":"app"}},[_c('MainLayout',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }